<template>
    <div>
        <h2>Subscription Type</h2>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>